import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=2a35c7e2&scoped=true"
import script from "./orderHistory.vue?vue&type=script&lang=js"
export * from "./orderHistory.vue?vue&type=script&lang=js"
import style0 from "./orderHistory.vue?vue&type=style&index=0&id=2a35c7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35c7e2",
  null
  
)

export default component.exports